import {
  AppBar,
  Box,
  Button,
  Card,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material"
import { useState } from "react"
import { Help } from "@mui/icons-material"
import { Stack } from "@mui/system"
import { Link } from "react-router-dom"
import logo from "../../assets/images/logo-rect.png"

const HeadNav = () => {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#fff",
        borderBottom: "solid 2px rgba(0,0,0,0.1)",
        //width: { sm: `calc(100% - ${drawerWidth}px)` },
        width: "100%",
        //pl: { sm: `${drawerWidth}px` },
        zIndex: "1000",
      }}
    >
      <Toolbar>
        <Stack
          direction="row"
          justifyContent={"space-between"}
          alignItems="center"
          spacing={2}
          sx={{ width: "100%" }}
        >

          <Stack direction="row" alignItems={"center"} spacing={2}>
            <Link
            to={"https://youstad.com"}
            target="_blank"
            >
            <img src={logo} alt="youstad_logo" style={{ height: "2.3rem" }} />

              {/* <Typography
                sx={{
                  fontWeight: 700,
                  letterSpacing: 1,
                  fontSize: { xs: 18, sm: 20 },
                }}
                color="primary"
              >
                RGIT ERP PORTAL
              </Typography> */}
            </Link>
            </Stack>
          <Stack direction="row" alignItems={"center"}>
            <IconButton>
              <Help color="primary" sx={{ fontSize: "1.8rem" }} />
            </IconButton>
            <Typography variant="h6" color="primary">
              Help
            </Typography>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}

export default HeadNav
